// live.js
import { Events } from "./events.js";
import { PerformanceMonitor } from "./performance.js";

export const Live = {
    _connection: null,
    _zlecenieId: null,
    _reconnectAttempts: 0,
    _maxReconnectDelay: 30000,
    _heartbeatInterval: null,
    _lastHeartbeat: null,
    _hasFocus: true,
    _focusBound: false,

    initWorkflowConnection(zlecenieId) {
        this._zlecenieId = zlecenieId;

        if (!window.signalR) {
            console.warn("SignalR niezaładowany");
            return;
        }

        const connection = new signalR.HubConnectionBuilder()
            .withUrl("/hubs/workflow")
            .withAutomaticReconnect()
            .build();

        this._connection = connection;

        connection.on("WorkflowUpdated", (id, workflowData) => {
            if (id !== this._zlecenieId) return;
            this._lastHeartbeat = Date.now();
            PerformanceMonitor.markLiveEventReceived();
            Events.emit("workflow:liveUpdated", workflowData);
        });

        connection.onclose(err => {
            console.warn("WorkflowHub rozłączony", err);
            Events.emit("workflow:liveDisconnected");
            this._scheduleReconnect();
        });

        const start = () => {
            connection.start()
                .then(() => {
                    this._reconnectAttempts = 0;
                    this._lastHeartbeat = Date.now();
                    connection.invoke("JoinZlecenieGroup", this._zlecenieId);
                    Events.emit("workflow:liveConnected");
                    this._startHeartbeat();
                })
                .catch(err => {
                    console.error("Błąd połączenia z WorkflowHub", err);
                    this._scheduleReconnect();
                });
        };

        start();
        this._bindFocusHandlers();
    },

    _scheduleReconnect() {
        this._stopHeartbeat();
        this._reconnectAttempts++;

        const delay = Math.min(
            1000 * Math.pow(2, this._reconnectAttempts),
            this._maxReconnectDelay
        );

        setTimeout(() => {
            if (!this._zlecenieId) return;
            this.initWorkflowConnection(this._zlecenieId);
        }, delay);
    },

    _startHeartbeat() {
        this._stopHeartbeat();
        this._heartbeatInterval = setInterval(() => {
            if (!this._connection) return;

            const now = Date.now();
            if (this._lastHeartbeat && now - this._lastHeartbeat > 60000) {
                this._connection.stop();
            }
        }, 15000);
    },

    _stopHeartbeat() {
        if (this._heartbeatInterval) {
            clearInterval(this._heartbeatInterval);
            this._heartbeatInterval = null;
        }
    },

    _bindFocusHandlers() {
        if (this._focusBound) return;
        this._focusBound = true;

        window.addEventListener("focus", () => {
            this._hasFocus = true;
            Events.emit("app:focus");
            if (!this._connection || this._connection.state !== "Connected") {
                if (this._zlecenieId) {
                    this.initWorkflowConnection(this._zlecenieId);
                }
            }
        });

        window.addEventListener("blur", () => {
            this._hasFocus = false;
            Events.emit("app:blur");
        });
    },

    dispose() {
        this._stopHeartbeat();
        if (this._connection) {
            this._connection.stop();
            this._connection = null;
        }
    }
};
